<template>
  <v-container
    fluid
  >
    <v-text-field
      class="ma-2"
      flat
      hide-details
      clearable
      label="Search"
      prepend-inner-icon="mdi-book-search"
      solo
      v-model="search"
    ></v-text-field>

    <v-card
      class="mx-auto"
    >
      <v-list-item v-for="book in books" :key="book.id" two-line
          :to="{ name: 'book', params: { id: book.id } }">
        <v-list-item-content>
          <v-list-item-title>{{ book.title }}</v-list-item-title>
          <v-list-item-subtitle>{{ book.author }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-card>

  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

const filterBooks = (needle) => (b) => (
  b.title.toLowerCase().indexOf(needle) !== -1 ||
  b.author.toLowerCase().indexOf(needle) !== -1
)

export default {
  name: 'HomeBooks',

  components: {
  },
  data () {
    return {
      search: ''
    }
  },
  computed: {
    ...mapGetters(['quoteBooks']),
    books () {
      if (this.search) {
        const needle = this.search.toLowerCase()
        return this.quoteBooks.filter(filterBooks(needle))
      }
      return this.quoteBooks
    }
  }
}
</script>
